import { Customer } from '../models';
import ApiResource from './ApiResource';

class CustomerResource extends ApiResource<Customer> {
  public endpoint = '/customers';
}

export const customerResource = new CustomerResource();
